import React from 'react';
import styled, { keyframes } from 'styled-components';
import PlacaForm from './PlacaForm';
import Button from '../common/Button';
import Container from '../common/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faCheckCircle, faLock, faShieldAlt, faMedal, faSearch, faPlay } from '@fortawesome/free-solid-svg-icons';

// ... (keyframes e estilos de fundo permanecem iguais)
const floatAnimation = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
`;

const HeroWrapper = styled.section`
    display: flex;
  align-items: center;
  min-height: 1vh; 
  
  padding: 100px 0; 
  
  position: relative;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.light};
`;

const HeroBg = styled.div`
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%; z-index: 0;
`;

const HeroBgCircle = styled.div`
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.2;
  animation: ${floatAnimation} ease-in-out infinite;
  &.circle-1 {
    width: 600px; height: 600px; background: ${({ theme }) => theme.colors.primary};
    top: -200px; right: -200px; animation-duration: 8s;
  }
  &.circle-2 {
    width: 400px; height: 400px; background: ${({ theme }) => theme.colors.accent};
    bottom: -100px; left: -100px; animation-duration: 10s; animation-delay: 2s;
  }
`;

// ==================================================================
// NOVA ESTRUTURA DE LAYOUT
// ==================================================================
const HeroContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 40px;
  width: 100%;
  position: relative;
  z-index: 1;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: column;
    gap: 60px;
  }
`;

const HeroText = styled.div`
  flex: 1;
  max-width: 550px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    align-items: center;
    text-align: center;
    max-width: 600px;
  }
`;

const FormWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 500px;
`;

// ==================================================================
// ESTILOS DO CONTEÚDO
// ==================================================================

const HeroTitle = styled.h1`
  font-size: 56px;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 24px;
  background: linear-gradient(90deg, ${({ theme }) => theme.colors.darker} 0%, ${({ theme }) => theme.colors.primary} 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) { font-size: 44px; }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) { font-size: 36px; }
`;

const HeroSubtitle = styled.p`
  font-size: 20px;
  color: ${({ theme }) => theme.colors.gray};
  line-height: 1.7;
  font-weight: 700;
  margin-bottom: 16px;
`;

const HeroBadge = styled.div`
  display: inline-flex; align-items: center; background: rgba(108, 92, 231, 0.1);
  color: ${({ theme }) => theme.colors.primary}; padding: 10px 20px;
  border-radius: ${({ theme }) => theme.radii.xl}; font-size: 14px;
  font-weight: 700; margin-bottom: 24px; gap: 10px;
`;

const HeroBenefits = styled.ul`
  margin: 0 0 32px; list-style: none; padding: 0; width: 100%;
`;

const BenefitItem = styled.li`
  margin-bottom: 12px; font-size: 18px; color: ${({ theme }) => theme.colors.dark};
  display: flex; align-items: center; gap: 10px;
  svg { color: ${({ theme }) => theme.colors.success}; font-size: 20px; }
`;

const HeroCtaContainer = styled.div`
  display: flex; gap: 20px; margin-bottom: 40px;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column; width: 100%;
  }
`;

const TrustBadges = styled.div`
  display: flex; flex-wrap: wrap; gap: 24px; margin-top: 40px;
`;

const TrustItem = styled.div`
  display: flex; align-items: center; gap: 8px; font-size: 14px;
  color: ${({ theme }) => theme.colors.gray};
  svg { color: ${({ theme }) => theme.colors.primary}; }
`;

// --- COMPONENTE JSX ---

const HeroSection = () => {
  const benefits = [
    "Roubo ou furto registrado", "Débitos (IPVA, multas, licenciamento)",
    "Histórico de proprietários", "Restrições e recalls", "Dados técnicos completos"
  ];

  return (
    <HeroWrapper id="home">
      <HeroBg>
        <HeroBgCircle className="circle-1" />
        <HeroBgCircle className="circle-2" />
      </HeroBg>
      <Container>
        <HeroContent>
          <HeroText>
            <HeroBadge>
              <FontAwesomeIcon icon={faBolt} />
              <span>CONSULTA EM TEMPO REAL</span>
            </HeroBadge>
            <HeroTitle>Descubra TUDO sobre qualquer veículo em 30 segundos</HeroTitle>
            <HeroSubtitle>Evite golpes e prejuízos! Nosso relatório completo revela:</HeroSubtitle>
            <HeroBenefits>
              {benefits.map(benefit => (
                <BenefitItem key={benefit}><FontAwesomeIcon icon={faCheckCircle} /><span>{benefit}</span></BenefitItem>
              ))}
            </HeroBenefits>
            {/* <HeroCtaContainer>
              <Button variant="primary"><FontAwesomeIcon icon={faSearch} /> Consultar Agora</Button>
              <Button variant="secondary"><FontAwesomeIcon icon={faPlay} /> Ver Demonstração</Button>
            </HeroCtaContainer> */}
            {/* <TrustBadges>
              <TrustItem><FontAwesomeIcon icon={faLock} /> <span>Pagamento 100% seguro</span></TrustItem>
              <TrustItem><FontAwesomeIcon icon={faShieldAlt} /> <span>Dados protegidos</span></TrustItem>
              <TrustItem><FontAwesomeIcon icon={faMedal} /> <span>+50.000 consultas/mês</span></TrustItem>
            </TrustBadges> */}
          </HeroText>
          <FormWrapper>
            <PlacaForm />
          </FormWrapper>
        </HeroContent>
      </Container>
    </HeroWrapper>
  );
};

export default HeroSection;